export class AnswerInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get answer() {
        return this.parent;
    }
    get app() {
        return this.answer.app;
    }
    get isAnswerPosed() {
        return !!this.answer.poseDate;
    }
    get isAnswerNotYetPosed() {
        return !this.isAnswerPosed;
    }
    get isAnswerCompleted() {
        return !!this.answer.completeDate;
    }
    get isAnswerNotYetCompleted() {
        return !this.isAnswerCompleted;
    }
    get isAnswerFinished() {
        return !!this.answer.finishDate;
    }
    get hasAnswerFullPoints() {
        return this.answer.points === this.answer.maxPoints;
    }
    get hasAnswerZeroPoints() {
        return this.answer.points === 0;
    }
    get indexInTray() {
        return this.app.tray.trayAnswers.allAnswersInLine.indexOf(this.answer);
    }
    get deltaToActiveQuestion() {
        return this.indexInTray - this.app.tray.trayLine.indexOfFrontalAnswer;
    }
    get isHistoricAnswer() {
        return this.deltaToActiveQuestion < 0;
    }
    get isFrontalAnswer() {
        return this.deltaToActiveQuestion === 0;
    }
    get isFutureAnswer() {
        return this.deltaToActiveQuestion > 0;
    }
    get isCurrentAnswer() {
        return this.app.stage.itemOnStage === this.answer;
    }
    get previousAnswerInTray() {
        if (this.indexInTray === 0)
            return undefined;
        return this.app.tray.trayAnswers.allAnswersInLine[this.indexInTray - 1];
    }
    get nextAnswerInTray() {
        if (this.indexInTray === this.app.tray.trayAnswers.numberOfAnswersInTray - 1)
            return undefined;
        return this.app.tray.trayAnswers.allAnswersInLine[this.indexInTray + 1];
    }
    get isAReward() {
        return this.indexInTray === -1;
    }
}
